import { ProjectsActionTypes } from '../types';
import { makeAsyncActionCreators } from '../../helpers';

const fetchProjectById = makeAsyncActionCreators(
  ProjectsActionTypes.fetchProjectById,
  ['projectId', 'specifiedProjectFields'],
  ['project'],
  ['error'],
);

const createProject = makeAsyncActionCreators(
  ProjectsActionTypes.createProject,
  ['project', 'customer', 'writer', 'editor', 'developmentalEditor', 'proProofreader', 'contentTeam', 'package', 'timelineSchedule', 'extensionFeeDeadline', 'isProjectTimelineShown', 'isProjectAccessBlocked', 'isEmailShouldBeSentOnBlock', 'salesOwner', 'customUpgradeRequest', 'printerType'],
  ['project', 'hubspotError'],
  ['error'],
);

const editProjectWithRelatedData = makeAsyncActionCreators(
  ProjectsActionTypes.editProjectWithRelatedData,
  ['customer', 'writer', 'editor', 'developmentalEditor', 'proProofreader', 'contentTeam', 'package', 'project', 'timelineSchedule', 'extensionFeeDeadline', 'isProjectTimelineShown', 'isProjectAccessBlocked', 'isEmailShouldBeSentOnBlock', 'salesOwner', 'customUpgradeRequest', 'printerType', 'navigate'],
  ['customer', 'writer', 'editor', 'developmentalEditor', 'proProofreader', 'contentTeam', 'package', 'project', 'hubspotError'],
  ['error'],
);

const deleteProjectById = makeAsyncActionCreators(
  ProjectsActionTypes.deleteProjectById,
  ['projectId', 'navigate'],
  ['project'],
  ['error'],
);

const toggleProjectArchivingById = makeAsyncActionCreators(
  ProjectsActionTypes.toggleProjectArchivingById,
  ['projectId', 'isProjectCompleted'],
  ['project'],
  ['error'],
);

const fetchChaptersAndResourcesByProjectId = makeAsyncActionCreators(
  ProjectsActionTypes.fetchChaptersAndResourcesByProjectId,
  ['projectId', 'permissions'],
  ['chapters', 'book', 'project', 'package', 'interviews'],
  ['error'],
);

const getBookSampleAndResourcesByProjectId = makeAsyncActionCreators(
  ProjectsActionTypes.getBookSampleAndResourcesByProjectId,
  ['projectId'],
  ['book', 'project', 'package', 'interviews'],
  ['error'],
);

const fetchChaptersAndResourcesByUser = makeAsyncActionCreators(
  ProjectsActionTypes.fetchChaptersAndResourcesByUser,
  ['permissions'],
  ['chapters', 'book', 'project', 'package'],
  ['error'],
);

const getBookSampleAndResourcesByUser = makeAsyncActionCreators(
  ProjectsActionTypes.getBookSampleAndResourcesByUser,
  [],
  ['book', 'project', 'package'],
  ['error'],
);

const fetchDataToCreateProject = makeAsyncActionCreators(
  ProjectsActionTypes.fetchDataToCreateProject,
  [],
  ['users', 'packages', 'prices'],
  ['error'],
);

const fetchDataToEditProject = makeAsyncActionCreators(
  ProjectsActionTypes.fetchDataToEditProject,
  ['projectId'],
  ['project', 'users', 'packages', 'prices', 'book'],
  ['error'],
);

const getDataForProjectsList = makeAsyncActionCreators(
  ProjectsActionTypes.getDataForProjectsList,
  ['filters', 'pagination', 'sortBy'],
  ['projects'],
  ['error'],
);

const fetchProjectOverviewDataByProjectId = makeAsyncActionCreators(
  ProjectsActionTypes.fetchProjectOverviewDataByProjectId,
  ['projectId', 'navigate'],
  ['project', 'members', 'package', 'book', 'interviews'],
  ['error'],
);

const fetchProjectOverviewDataByCustomerId = makeAsyncActionCreators(
  ProjectsActionTypes.fetchProjectOverviewDataByCustomerId,
  ['customerId', 'navigate'],
  ['project', 'members', 'package', 'book', 'interviews'],
  ['error'],
);

const addWriterToProject = makeAsyncActionCreators(
  ProjectsActionTypes.addWriterToProject,
  ['projectId', 'writerId', 'writerLevelForProject'],
  ['project'],
  ['error'],
);

const moveToNextStageOfProject = makeAsyncActionCreators(
  ProjectsActionTypes.moveToNextStageOfProject,
  ['projectId', 'isEmailsIncluded', 'bookFieldsToUpdate'],
  ['project'],
  ['error'],
);

const fetchTimelineDataByCustomer = makeAsyncActionCreators(
  ProjectsActionTypes.fetchTimelineDataByCustomer,
  ['customerId'],
  ['project', 'package', 'members', 'book'],
  ['error'],
);

const toggleUserEnableToEditDraft = makeAsyncActionCreators(
  ProjectsActionTypes.toggleUserEnableToEditDraft,
  ['projectId', 'userRole'],
  ['project'],
  ['error'],
);

const toggleUserEnableToEditOutline = makeAsyncActionCreators(
  ProjectsActionTypes.toggleUserEnableToEditOutline,
  ['projectId', 'userRole'],
  ['project'],
  ['error'],
);

const toggleUserEnableToDownloadOutline = makeAsyncActionCreators(
  ProjectsActionTypes.toggleUserEnableToDownloadOutline,
  ['projectId', 'userRole'],
  ['project'],
  ['error'],
);

const getProjectsDataForExcel = makeAsyncActionCreators(
  ProjectsActionTypes.getProjectsDataForExcel,
  ['filters', 'sortBy'],
  ['projects'],
  ['error'],
);

const customerReviewedUpgrades = makeAsyncActionCreators(
  ProjectsActionTypes.customerReviewedUpgrades,
  [],
  [],
  ['error'],
);

const getDataFromHubspot = makeAsyncActionCreators(
  ProjectsActionTypes.getDataFromHubspot,
  ['hubspotDealID'],
  ['users', 'warningMessage'],
  ['error'],
);

const editorSeenRequestForUpgrade = makeAsyncActionCreators(
  ProjectsActionTypes.editorSeenRequestForUpgrade,
  ['projectId'],
  ['project'],
  ['error'],
);

const getProjectAndBookData = makeAsyncActionCreators(
  ProjectsActionTypes.getProjectAndBookData,
  ['projectId'],
  ['book', 'project', 'interviews'],
  ['error'],
);

const cancelUpgradeRequest = makeAsyncActionCreators(
  ProjectsActionTypes.cancelUpgradeRequest,
  ['projectId', 'upgradeRequestId'],
  ['project'],
  ['error'],
);
const completeUpgradeRequest = makeAsyncActionCreators(
  ProjectsActionTypes.completeUpgradeRequest,
  ['projectId', 'upgradeRequestId'],
  ['project', 'package'],
  ['error'],
);

const getNextStageForProject = makeAsyncActionCreators(
  ProjectsActionTypes.getNextStageForProject,
  ['projectId'],
  ['project'],
  ['error'],
);

export default {
  fetchProjectOverviewDataByProjectId,
  fetchProjectOverviewDataByCustomerId,
  getDataForProjectsList,
  fetchProjectById,
  createProject,
  editProjectWithRelatedData,
  deleteProjectById,
  toggleProjectArchivingById,
  fetchChaptersAndResourcesByProjectId,
  fetchChaptersAndResourcesByUser,
  fetchDataToCreateProject,
  fetchDataToEditProject,
  addWriterToProject,
  moveToNextStageOfProject,
  fetchTimelineDataByCustomer,
  toggleUserEnableToEditDraft,
  toggleUserEnableToEditOutline,
  toggleUserEnableToDownloadOutline,
  getProjectsDataForExcel,
  customerReviewedUpgrades,
  getDataFromHubspot,
  editorSeenRequestForUpgrade,
  getBookSampleAndResourcesByUser,
  getBookSampleAndResourcesByProjectId,
  getProjectAndBookData,
  cancelUpgradeRequest,
  completeUpgradeRequest,
  getNextStageForProject,
};
